import { PlaceType } from 'src/types';

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface StatusResponse {
  success: boolean;
  error: string | null;
  errorMessage?: string | null;
}

export interface Building {
  townId: number;
  buildingId: number;
  address: string;
  inheritedEnabled?: boolean;
  inheritedDisabledReason?: string;
  ownEnabled?: boolean;
  ownDisabledReason?: string | null;
  testData?: boolean;
  hasParkings?: boolean;
}

export interface Floor {
  townId: number;
  buildingId: number;
  floorId: number;
  title: string;
  planUnderlayLoaded?: boolean;
  inheritedEnabled?: boolean;
  inheritedDisabledReason?: string;
  ownEnabled?: boolean;
  ownDisabledReason?: string | null;
  testData?: boolean;
  isParking?: boolean;
}

export interface Town {
  townId: number;
  townName: string;
  ownEnabled?: boolean;
  ownDisabledReason?: string | null;
  testData?: boolean;
  timeZone?: number;
  hasParkings?: boolean;
}

export interface EmployeeShortInfo {
  employeeNumber: string;
  firstName: string;
  lastName: string;
  middleName: string;
}

export interface PlaceInfo {
  placeId: number;
  title: string | null;
  typeId: PlaceType;
  floorId: number;
}

export interface OrganizationInfo {
  id: number;
  name: string | null;
  parent: OrganizationInfo | null;
}

export interface RelatedFloor {
  floorId: number;
  title: string;
  planUnderlayLoaded: boolean;
  enabled: boolean;
  disabledReason: string;
  buildingId: number;
  buildingAddress: string;
  townId: number;
  townName: string;
}

export interface SpaceInfo {
  spaceId: number;
  title: string;
  isDeleted: boolean;
  organizations: OrganizationInfo[];
  places: PlaceInfo[];
  relatedFloors: RelatedFloor[];
  administrator: EmployeeShortInfo | null;
}
